import { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const CheckIcon: FC<IconProps> = ({ className }) => (
    <svg className={className} width="19" height="19" fill="none">
        <path
            fill="currentColor"
            d="M17.087 3.794a.633.633 0 0 0-.435.192L6.966 13.67 2.981 9.686a.633.633 0 1 0-.896.895l4.434 4.434a.634.634 0 0 0 .895 0L17.548 4.88a.633.633 0 0 0-.46-1.087Z"
        />
    </svg>
);